import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container pt-5 mx-auto overflow-hidden" }

import Navigation from '@/components/Nav/Navigation.vue';
import Footer from '@/components/Nav/Footer.vue';
import Status from '@/components/System/Status.vue';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Status),
    _createVNode(Navigation),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_router_view)
    ]),
    _createVNode(Footer, { class: "flex-shrink hidden lg:flex" })
  ], 64))
}
}

})